
import * as React from 'react';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function QuickTracking() {
  const [trackingInput, setTrackingInput] = useState('');
  const navigate = useNavigate();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    const trimmed = trackingInput.trim();
    if (!trimmed) return;

    const isEmail = trimmed.includes('@');
    const type = isEmail ? 'email' : 'tracking';

    try {
      navigate(
        `/order-tracking?q=${encodeURIComponent(trimmed)}&type=${type}`
      );
    } catch (err) {
      console.error('Navigation error:', err);
      // optional: show user‑friendly feedback here
    }
  };

  return (
    <section className="py-10 sm:py-16 bg-[#FAFDF7]">
      <div className="max-w-4xl mx-auto px-4 sm:px-6">
        <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden">
          <div className="grid grid-cols-1 lg:grid-cols-5 gap-0">
            {/* Left: Info */}
            <div className="lg:col-span-2 bg-[#2E7D32] p-6 sm:p-8 flex flex-col justify-center">
              <div className="w-12 h-12 rounded-xl bg-white/15 flex items-center justify-center mb-4">
                <i className="ri-route-line text-2xl text-white"></i>
              </div>
              <h3 className="text-lg sm:text-xl font-serif text-white mb-2">
                Suivez Votre Colis
              </h3>
              <p className="text-sm text-white/70 leading-relaxed">
                Entrez votre numéro de tracking ou votre email pour suivre votre
                commande en temps réel.
              </p>
              <div className="flex items-center gap-4 mt-5">
                <div className="flex items-center gap-1.5">
                  <span className="w-1.5 h-1.5 rounded-full bg-[#A5D6A7] animate-pulse"></span>
                  <span className="text-[11px] text-white/60 font-medium">
                    Suivi en direct
                  </span>
                </div>
                <div className="flex items-center gap-1.5">
                  <i className="ri-shield-check-line text-xs text-white/60"></i>
                  <span className="text-[11px] text-white/60 font-medium">
                    100% sécurisé
                  </span>
                </div>
              </div>
            </div>

            {/* Right: Form */}
            <div className="lg:col-span-3 p-6 sm:p-8 flex flex-col justify-center">
              <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                  <label className="text-xs font-medium text-gray-500 uppercase tracking-wider mb-2 block">
                    Numéro de tracking ou email
                  </label>
                  <div className="relative">
                    <i className="ri-barcode-line absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 text-lg"></i>
                    <input
                      type="text"
                      value={trackingInput}
                      onChange={(e) => setTrackingInput(e.target.value)}
                      placeholder="Ex: 1Z999AA1012345678 ou votre@email.com"
                      className="w-full pl-11 pr-4 py-3.5 text-sm text-gray-800 placeholder-gray-400 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#2E7D32]/20 focus:border-[#2E7D32] transition-all bg-gray-50/50"
                    />
                  </div>
                </div>
                <button
                  type="submit"
                  disabled={!trackingInput.trim()}
                  className="w-full py-3.5 bg-[#2E7D32] text-white text-sm font-semibold rounded-xl hover:bg-[#1B5E20] transition-colors cursor-pointer disabled:opacity-40 disabled:cursor-not-allowed flex items-center justify-center gap-2 whitespace-nowrap"
                >
                  <i className="ri-search-line text-base"></i>
                  Suivre ma commande
                </button>
              </form>

              {/* Carriers */}
              <div className="flex items-center justify-center gap-6 mt-5 pt-4 border-t border-gray-100">
                <span className="text-[10px] text-gray-400 font-medium uppercase tracking-wider">
                  Transporteurs :
                </span>
                <div className="flex items-center gap-4">
                  {['UPS', 'FedEx', 'DHL'].map((carrier) => (
                    <span
                      key={carrier}
                      className="text-xs font-bold text-gray-400"
                    >
                      {carrier}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
